import React from "react";
function Recipe({recipe}) {

    return (
        <div>
            <p>{recipe.name}</p>
        </div>
    )
}
export default Recipe;